import type { callToAction } from '@stereoagency/sanity-schema';
import type { CallToActionProps } from '@stereoagency/ui';
import linkAsProps from './linkAsProps';

type Action = typeof callToAction.schema.callToAction;

export default function actionAsProps(action: Action): CallToActionProps {
  return {
    variant: action.variant ?? 'button/primary',
    label: action.label,
    ...linkAsProps(action)
  };
}
